import {BaseCachedService} from './Core/BaseCachedService';

class SurveyAnswerPlantQuantityStockTypeService extends BaseCachedService {
    get Url() { return super.Url + "/surveyAnswerPlantQuantityStockTypes"; }
}

export const service = new SurveyAnswerPlantQuantityStockTypeService();

